import BiogCard from '../trophys/BiogCard';

import teamAndy from '../../assets/team-andy.jpg';
import teamTracy from '../../assets/team-tracy.jpg';
import teamEd from '../../assets/team-ed.jpg';
import teamCommunity from '../../assets/team-community.jpg';

import MiniHeroSection from '../containers/MiniHeroSection';

const MeetTheTeam = () => {
  return (
    <div className="mb-5">
      <MiniHeroSection
        titleText="Meet The Team"
        sectionClassExtra="mb-4"
        iconName="fa-users"
      />

      <div className="container">
        <div className="mb-4">
          This website is designed, developed, run, and maintained by the
          following team.
        </div>

        <div className="row row-cols-1 row-cols-lg-2 g-3 mb-3">
          <BiogCard
            name="Andy Eder"
            role="Owner + Software Engineer"
            bio="Hi, I'm Andy and I have owned a Renaultsport Clio 182 Trophy since
              2007. As part of a welcoming and widening Trophy community I
              thought it might be a fun idea to reach-out in an attempt to pull
              together some kind of Trophy register. Hence, this small website
              project was born - a project that I wanted to share with the
              community. I am delighted to welcome my good friend and
              professional colleague, Tracy, to the team."
            image={teamAndy}
            links={{
              github: 'https://github.com/andyeder',
              linkedin: 'https://linkedin.com/in/andyeder/',
              website: 'https://andyeder.uk',
            }}
          />

          <BiogCard
            name="Tracy Gilmore"
            role="Principal Frontend Software Engineer"
            bio="Hello, I'm Tracy Gilmore (and yes it is an odd name for a guy.)
              Over the last few years I have had the pleasure of working
              alongside Andy on another project and am very pleased to be
              joining him in developing and maintaining TrophyTracker. You might
              have already noticed some changes, including this Meet the Team
              page, and over the coming months I hope to bring new features and
              facilities to benefit the community."
            image={teamTracy}
            links={{
              github: 'https://github.com/TracyGJG',
              linkedin:
                'https://linkedin.com/in/tracy-gregory-gilmore-7252112/',
              devto: 'https://dev.to/tracygjg',
            }}
          />

          <BiogCard
            name="Ed Chadwick"
            role="Community Ambassador"
            bio="Ed has been an influential figure in terms of his support and commitment to all things Clio Trophy! His petrol-fuelled storytelling is a thing of legend, along with his appetite for breakfast."
            image={teamEd}
            links={{
              website: 'https://cliotrophy.co.uk',
            }}
          />

          <BiogCard
            name="ClioTrophy Community"
            role="Supporters"
            bio="The ClioTrophy.co.uk Community has been a huge help in sourcing and providing the information for this website. Without their help, this site would not exist - thank you, all!"
            image={teamCommunity}
            links={{
              website: 'https://cliotrophy.co.uk',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;
